import { jsx, jsxs } from "react/jsx-runtime";
import { Trigger, Button, ModalDialog, Box, Heading, Paragraph, Anchor, Text, IconArrowRightOutline } from "@zillow/constellation";
const PLATFORM_LINKS = {
  dotloop: "https://www.dotloop.com/#/signin",
  followUpBoss: "https://app.followupboss.com/login",
  premierAgent: "https://premieragent.zillow.com/crm/agentlogin/",
  support: "https://www.zillow.com/help/",
  workspace: "https://app.zillow-workspace.com"
};
function AgentLoginModal({
  title
}) {
  return /* @__PURE__ */ jsx(Trigger, { triggered: ({
    isOpen,
    onClose
  }) => /* @__PURE__ */ jsx(ModalDialog, { scrollDocument: true, isOpen, size: {
    default: ModalDialog.SIZES.FULL_SCREEN,
    md: ModalDialog.SIZES.SM
  }, onClose, renderBody: /* @__PURE__ */ jsxs(Box, { sx: {
    display: "flex",
    flexDirection: "column",
    padding: "0 $spacing.lg $spacing.lg $spacing.lg"
  }, children: [
    /* @__PURE__ */ jsx(Heading, { level: "4", marginBottom: "sm", children: "Sign In" }),
    /* @__PURE__ */ jsx(Paragraph, { marginBottom: "lg", children: "Select which software you'd like to sign in to:" }),
    /* @__PURE__ */ jsx(AgentPlatformButton, { title: "Zillow Workspace", description: "Access dotloop, Showcase & Zillow Media Experts", link: PLATFORM_LINKS.workspace, marginBottom: "md" }),
    /* @__PURE__ */ jsx(AgentPlatformButton, { title: "Premier Agent & Profiles", description: "Lead Generation & Profile Management", link: PLATFORM_LINKS.premierAgent, marginBottom: "md" }),
    /* @__PURE__ */ jsx(AgentPlatformButton, { title: "Follow Up Boss", description: "Real Estate CRM & Lead Management", link: PLATFORM_LINKS.followUpBoss, marginBottom: "md" }),
    /* @__PURE__ */ jsx(AgentPlatformButton, { title: "dotloop", description: "Real Estate Transaction Management", link: PLATFORM_LINKS.dotloop }),
    /* @__PURE__ */ jsxs(Paragraph, { marginTop: {
      default: "xxl",
      md: "lg"
    }, textAlign: "center", children: [
      "Need help?",
      " ",
      /* @__PURE__ */ jsx(Box, { as: Anchor, href: PLATFORM_LINKS.support, sx: {
        "&&": {
          fontWeight: "$fontWeights.bodyHeading"
        }
      }, children: "Contact support" })
    ] })
  ] }) }), children: /* @__PURE__ */ jsx(Button, { as: "button", buttonType: "secondary", type: "button", children: title }) });
}
const ButtonLink = (props) => /* @__PURE__ */ jsx(Button, { as: "a", ...props });
function AgentPlatformButton({
  description,
  link,
  marginBottom,
  title
}) {
  return /* @__PURE__ */ jsxs(Box, { as: ButtonLink, buttonType: "tertiary", href: link, marginBottom, rel: "noopener noreferrer", sx: {
    "&&": {
      padding: "$spacing.sm $spacing.md"
    },
    borderRadius: "$radii.xl",
    display: "flex",
    textAlign: "left"
  }, target: "_blank", children: [
    /* @__PURE__ */ jsxs(Box, { sx: {
      alignItems: "flex-start",
      display: "flex",
      flex: 1,
      flexDirection: "column"
    }, children: [
      /* @__PURE__ */ jsx(Text, { fontType: "h5", marginBottom: "xxs", children: title }),
      /* @__PURE__ */ jsx(Text, { fontColor: "gray600", fontType: "bodySmall", children: description })
    ] }),
    /* @__PURE__ */ jsx(Box, { sx: {
      backgroundColor: "$colors.brand",
      borderRadius: "$radii.ellipse"
    }, children: /* @__PURE__ */ jsx(IconArrowRightOutline, { size: "lg", fontColor: "textWhite" }) })
  ] });
}
export {
  AgentLoginModal as default
};
